<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <h5 class="mb-0">Copies à corriger</h5>
    </div>

    <div class="card-body p-15 p-sm-20 p-md-25">
      <div v-if="loading" class="text-center py-5">
        <div class="spinner-border text-primary" role="status"></div>
        <p class="mt-2 text-muted">Chargement des copies à corriger...</p>
      </div>

      <div v-else-if="sessions.length === 0" class="text-center py-5 text-muted">
        <i class="fa fa-check-circle fa-3x text-success mb-3 d-block"></i>
        Aucune copie en attente de correction.
      </div>

      <div v-else class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th class="text-uppercase fw-medium text-body-tertiary fs-13 pt-0">Composition</th>
              <th class="text-uppercase fw-medium text-body-tertiary fs-13 pt-0">Étudiant</th>
              <th class="text-uppercase fw-medium text-body-tertiary fs-13 pt-0">Code session</th>
              <th class="text-uppercase fw-medium text-body-tertiary fs-13 pt-0">Date soumission</th>
              <th class="text-uppercase fw-medium text-body-tertiary fs-13 pt-0 text-end pe-0">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="session in sessions" :key="session.resultatId">
              <td class="fw-medium text-black-emphasis">{{ session.compositionTitre }}</td>
              <td class="fw-medium text-black-emphasis">{{ session.etudiant }}</td>
              <td class="fw-medium text-black-emphasis">{{ session.sessionCode }}</td>
              <td class="fw-medium text-black-emphasis">{{ formatDate(session.dateSoumission) }}</td>
              <td class="text-end pe-0">
                <router-link
                  :to="{ name: 'CorrectionSessionPage', params: { sessionId: session.sessionId } }"
                  class="btn btn-primary btn-sm"
                >
                  <i class="fa fa-pencil me-1"></i> Corriger
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import ApiService from "@/services/ApiService";
import { error } from "@/utils/utils";

interface SessionACorriger {
  resultatId: number;
  sessionId: number;
  sessionCode: string;
  compositionId: number;
  compositionTitre: string;
  etudiant: string;
  dateSoumission: string;
}

export default defineComponent({
  name: "SessionsACorrigerPage",
  setup() {
    const sessions = ref<SessionACorriger[]>([]);
    const loading = ref(true);

    const fetchSessions = async () => {
      loading.value = true;
      try {
        const { data } = await ApiService.get('/professeur/sessions-a-corriger');
        sessions.value = data.data || [];
      } catch (err: any) {
        error(err.response?.data?.message || "Impossible de charger les copies à corriger");
      } finally {
        loading.value = false;
      }
    };

    const formatDate = (date: string) => {
      return new Date(date).toLocaleDateString("fr-FR", {
        day: "2-digit",
        month: "long",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    };

    onMounted(() => {
      fetchSessions();
    });

    return {
      sessions,
      loading,
      formatDate,
    };
  },
});
</script>